import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { etherealBiome } from '../biomeArchetypes';
import { Z_LAYERS } from '../../../game/rendering/Z_LAYERS';

/** Sky-whale — a bright ethereal sky realm with a vast whale skeleton drifting
 *  through the clouds. Proves the leviathans kind is NOT sunken-only — the same
 *  silhouette library + effect kind works over a bright palette. The whale is
 *  pale and luminous against a dawn-pink sky, with a warm edge-highlight rim. */
export const SKY_WHALE = etherealBiome({
  id: 'sky_whale',
  sky: { from: 0xf0d4b8, to: 0xc4a8d8 },
  celestial: { atX: 0.72, atY: 0.15, color: 0xfff8e0, haloColor: 0xffe8c0, size: 90, haloScale: 3.0, coreAlpha: 0.7, haloAlpha: 0.15 },
  cloudBands: { count: 6, color: 0xe8d0c0, sizeMin: 300, sizeMax: 550, alphaMin: 0.08, alphaMax: 0.18, driftPxPerSec: 6, bandYMin: 0.08, bandYMax: 0.35 },
  motes: { colors: [0xfff8e0, 0xffe8c0], count: 18, sizeMin: 4, sizeMax: 10, driftPx: 24, periodMinMs: 8000, periodMaxMs: 16000, alphaMin: 0.3, alphaMax: 0.7 },
  rays: { color: 0xfff0d0 },
  glow: {
    blobs: [
      { color: 0xffe8c0, atX: 0.72, atY: 0.15, size: 400, alpha: 0.08 },
      { color: 0xe8d0c0, atX: 0.3, atY: 0.5, size: 350, alpha: 0.05 },
    ],
    breathe: { periodMs: 7000, min: 0.7, max: 1.3 },
  },
  lightField: { palette: [0xfff0d0, 0xe8d0c0], count: 12, sizeMin: 80, sizeMax: 200, alphaMin: 0.04, alphaMax: 0.14, driftRadius: 40, periodMinMs: 9000, periodMaxMs: 18000 },
  weather: { mode: 'rise', color: 0xfff8e0, colorEnd: 0xffe8c0,
    size: 8, frequencyMs: 200, lifespanMs: 6000, speed: 14, gravityY: -8, windX: 6, alphaEnd: 0.5,
    gust: { periodMs: 5000, min: 0.5, max: 1.5 } },
  flicker: { color: 0xfff8e0, size: 180, baseAlpha: 0.06, flickerAmp: 0.04, hzMin: 0.5, hzMax: 2, anchors: [{ atX: 0.72, atY: 0.15 }, { atX: 0.3, atY: 0.5 }] },
  extraLayers: [
    // The sky-whale: a whaleSkeleton silhouette drifting through the clouds.
    // Bright palette → pale luminous whale with a warm rim. Proves leviathans
    // generalize beyond the sunken biome.
    {
      kind: 'leviathans',
      shape: 'whaleSkeleton',
      planes: [
        { count: 1, widthMin: 600, widthMax: 900, speedMin: 6, speedMax: 12, alpha: 0.15, tint: 0xfff8e0, depth: Z_LAYERS.LEVIATHAN_FAR },
        { count: 1, widthMin: 900, widthMax: 1400, speedMin: 3, speedMax: 7, alpha: 0.22, tint: 0xffe8c0, depth: Z_LAYERS.LEVIATHAN_NEAR },
      ],
      bob: { ampPx: 20, periodMinMs: 10000, periodMaxMs: 20000 },
      edgeHighlight: true,
      edgeColor: 0xfff0d0,
      detail: 1,
      direction: 'right',
      bandYMin: 0.15,
      bandYMax: 0.5,
    },
  ],
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.sky.far, shape: 'peaks', color: 0xe8d0c0, speed: 0.02, height: 400, alpha: 0.3, detail: 0.6 },
    { svg: OTHERWORLD_BACKDROPS.sky.mid, shape: 'peaks', color: 0xd8c0b0, speed: 0.06, height: 280, alpha: 0.5, detail: 0.8 },
    { svg: OTHERWORLD_BACKDROPS.sky.near, shape: 'peaks', color: 0xc8b0a0, speed: 0.12, height: 180, alpha: 0.7, detail: 1.0 },
  ],
  closer: { vignette: { color: 0xc4a8d8, edgeAlpha: 0.2 }, grade: { top: 0xf0d4b8, bottom: 0xc4a8d8, strength: 0.08, blend: 'normal' } },
});
